import { Controller } from "@hotwired/stimulus"

import { Elm } from "@/components/elm/Venue/Reviews.elm"

import { logDecodingError } from "@/helpers/airbrake"
import { isTextOverflowed } from "@/helpers/toggle_content"

const CRITERION_SCORE_ATTR = "data-criterion-score"

export default class extends Controller {
  static targets = ["container"]

  static values = {
    elmFlags: { type: Object, default: {} }
  }
  declare readonly elmFlagsValue: Flags

  declare readonly containerTarget: HTMLElement

  connect(): void {
    // Ensure the reviews section scrolls into view if accessed via #hash,
    // since it's lazy-loaded with Turbo.
    if (window.location.hash === "#reviews") {
      this.element.scrollIntoView({ block: "start" })
    }

    const flags = this.elmFlagsValue
    const app = Elm.Venue.Reviews.init({ node: this.containerTarget, flags })

    app.ports.flagDecodingError.subscribe(() => logDecodingError(flags))
    app.ports.visibleReviewsChanged.subscribe((tabPanelId: string) => {
      window.requestAnimationFrame(() => {
        const textOverflowStates = [
          ...document.querySelectorAll(`#${tabPanelId} [itemprop="review"]`)
        ].reduce<[string, boolean][]>((acc, review) => {
          const content = review.querySelector<HTMLElement>("[data-collapsible]")!

          return [...acc, [review.id, isTextOverflowed(content)]]
        }, [])

        app.ports.textOverflowChanged.send(textOverflowStates)
      })
    })

    this.animateReviewsCriteria()
  }

  private animateReviewsCriteria(): void {
    const items = [...document.querySelectorAll(`[${CRITERION_SCORE_ATTR}]`)]

    const observer = new window.IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target as HTMLElement
          const score = target.getAttribute(CRITERION_SCORE_ATTR)!

          target.style.transform = `translateX(${+score * 10 - 100}%)`
          observer.unobserve(target)
        }
      })
    })

    items.forEach((item) => observer.observe(item))
  }
}
